module.exports = __webpack_public_path__ + "fonts/NittiGrotesk-Light.woff";